export const home = {
  'hero.eyebrow': 'CSSBuy Spreadsheet • Produtos • Guias • QC • Envio',
  'hero.h1': 'CSSBuy Spreadsheet: Encontre Produtos, Links e Guias em um Só Lugar',
  'hero.subtitle': 'Explore o CSSBuy Spreadsheet, descubra produtos e links, compare opções e encontre informações práticas sobre QC, armazém, custos de envio e compras internacionais.',
  'hero.cta.primary': 'Explorar CSSBuy Spreadsheet',
  'hero.cta.secondary': 'Ver Guias CSSBuy',
  'hero.trust': 'Informação organizada • Guias práticos • Comparações claras • Conteúdo atualizado',

  'spreadsheet.h2': 'Seu ponto de partida para o CSSBuy Spreadsheet',
  'spreadsheet.text': 'Encontrar produtos e entender compras internacionais pode ser confuso. Organizamos informações, links, guias e comparações relacionadas ao CSSBuy em um só lugar para ajudar você a pesquisar melhor e tomar decisões mais informadas.',
  'spreadsheet.cta': 'Explorar CSSBuy Spreadsheet',

  'what.h2': 'O que é o CSSBuy Spreadsheet?',
  'what.text': 'O CSSBuy Spreadsheet é uma forma prática de organizar e pesquisar produtos, links e informações relacionadas ao CSSBuy. Você pode comparar categorias, verificar informações disponíveis e encontrar guias sobre QC, armazenamento e envio antes de tomar uma decisão.',

  'how.h2': 'Como usar o CSSBuy Spreadsheet',
  'how.step1.title': 'Encontre um produto',
  'how.step1.desc': 'Pesquise a categoria ou produto desejado.',
  'how.step2.title': 'Verifique as informações',
  'how.step2.desc': 'Confira descrição, vendedor, preço e disponibilidade.',
  'how.step3.title': 'Compare opções',
  'how.step3.desc': 'Compare produtos usando informações organizadas.',
  'how.step4.title': 'Confira o QC',
  'how.step4.desc': 'Aprenda o que verificar nas fotos e inspeções.',
  'how.step5.title': 'Analise o envio',
  'how.step5.desc': 'Considere peso, volume, destino e método.',
  'how.step6.title': 'Tome uma decisão informada',
  'how.step6.desc': 'Confirme sempre as informações atuais antes de comprar.',

  'categories.h2': 'Categorias populares do CSSBuy Spreadsheet',
  'categories.cta': 'Ver todas as categorias',

  'guides.h2': 'Guias CSSBuy mais populares',
  'guides.cta': 'Ver todos os guias',

  'shipping.h2': 'CSSBuy Shipping Cost: entenda os custos',
  'shipping.text': 'O custo de envio pode variar conforme peso, volume, destino, método de transporte e condições atuais. Aprenda quais fatores podem influenciar o preço antes de finalizar um pedido.',
  'shipping.cta': 'Ver CSSBuy Shipping Cost',

  'qc.h2': 'CSSBuy QC: saiba o que verificar',
  'qc.checks': 'Fotos, Tamanho, Cor, Costuras, Detalhes, Possíveis defeitos, Quantidade, Embalagem',
  'qc.cta': 'Aprender sobre QC',

  'review.h2': 'CSSBuy Review: o que analisar',
  'review.table.factor': 'Fator',
  'review.table.check': 'O que verificar',
  'review.cta': 'Ler CSSBuy Review',

  'safety.h2': 'CSSBuy é legítimo?',
  'safety.text': 'Antes de utilizar qualquer serviço internacional, verifique o domínio, políticas, pagamentos, condições de envio e informações atuais. Não confie apenas em avaliações ou ofertas de terceiros.',
  'safety.cta': 'Ver Guia de Segurança',

  'faq.h2': 'Perguntas Frequentes sobre CSSBuy Spreadsheet',
  'faq.cta': 'Ver todas as FAQ',

  'final.h2': 'Pronto para explorar o CSSBuy Spreadsheet?',
  'final.text': 'Comece sua pesquisa, encontre recursos úteis e continue para o nosso site principal quando estiver pronto.',
  'final.cta': 'Explorar CSSBuy Spreadsheet',

  'nav.home': 'Início',
  'nav.guides': 'Guias',
  'nav.shoppingGuide': 'Guia de Compras',
  'nav.categories': 'Categorias',
  'nav.review': 'Review',
  'nav.shipping': 'Envio',
  'nav.qc': 'QC',
  'nav.safety': 'Segurança',
  'nav.faq': 'FAQ',
  'nav.article': 'Artigo',
  'nav.lang': 'Idioma',

  'cta.main1': 'CSSBuy Spreadsheet',
  'cta.main2': 'Buy it now',
  'cta.view': 'Ver Categoria',
  'cta.explore': 'Explorar',
  'cta.read': 'Ler Artigo',

  'footer.about': 'Sobre',
  'footer.policy': 'Política Editorial',
  'footer.contact': 'Contato',
  'footer.privacy': 'Privacidade',
  'footer.terms': 'Termos',
  'footer.disclaimer': 'Este site é um recurso informativo independente e não é afiliado ou endossado pela CSSBuy, salvo indicação expressa.',
  'footer.rights': 'Todos os direitos reservados.',

  'notFound.title': 'Página não encontrada',
  'notFound.subtitle': 'A página que você está procurando não existe. Volte para a página inicial e continue explorando.',
  'notFound.back': 'Voltar para Início',

  'article.title': 'Guia CSSBuy Spreadsheet 2026 — Como Encontrar Produtos e Comprar com Confiança',
  'article.meta': 'Aprenda a usar o CSSBuy Spreadsheet para encontrar produtos, verificar links, entender custos de envio e tomar decisões informadas nas compras internacionais.',
  'article.author': 'Equipe CSSBuy Spreadsheet',
  'article.published': 'Publicado em 30 de agosto de 2026',
  'article.updated': 'Atualizado em 30 de agosto de 2026',
  'article.toc': 'Conteúdo',
  'article.takeaways': 'Principais Conclusões',
  'article.faq': 'Perguntas Frequentes',
  'article.related': 'Artigos Relacionados',
  'article.back': 'Voltar para Início',
  'article.notFound': 'Artigo não encontrado.',

  'pillar.h2': 'Guias e Artigos CSSBuy',
  'pillar.subtitle': 'Explore nossos guias detalhados sobre CSSBuy Spreadsheet, cobrindo review, envio, QC, armazém, cupons e comparações.',
  'pillar.read': 'Ler artigo',
};

export default home;